import { writable } from "svelte/store";
import { service } from "./services";
import type {  ApiResultOfListOfGame as ApiResultOfListOfAddGroupResponse, ApiResultOfListOfGroupDTO, Group, GroupDTO } from "./walletapi";


export const groups = writable<GroupDTO[]>([]);


export async function RefreshGroups() {
    try {
    
        
        let response: ApiResultOfListOfGroupDTO = await service.walletapi.groupList({
            Token: sessionStorage.token,
        });

   

        if (response.Success && response.Data) {
            // Procesar y convertir los datos para asegurar tipos correctos
            const processedGroups: GroupDTO[] = response.Data.map(group => ({
                ...group,
                Id: Number(group.Id),
                ParentId: group.ParentId !== null && group.ParentId !== undefined ? Number(group.ParentId) : undefined
            }));

            groups.set(processedGroups);
        }
    } catch (error) {
    }
}

export function GroupChanged(group: Group)
{   
    groups.update(list => {
        let groupIndex = list.findIndex(p => p.Id == group.Id);
        if (groupIndex == -1)
        {
            // no such group
            return list;
        }
        
        list[groupIndex] = group;

        return list;
    });
};

export function GroupAdded(group: Group)
{   
    groups.update(list => {
        list.unshift(group);
        return list;
    });
};
